import PropTypes from "prop-types";
const PropTypeDropdown = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired
    })
  ),
  stackDirection: PropTypes.oneOf(["horisontal", "vertical"]),
  selectedOption: PropTypes.object,
  placeholder: PropTypes.string,
  onChange: PropTypes.func
};
export default PropTypeDropdown;
